<template>
  <div class="nodata" v-show="isShow" :style="outStyle">
    <div class="nodata-in">
      <img class="nodata_img" :src="require('./img/' + category)" alt="" />
      <div class="nodata_word">{{ tipword }}</div>
    </div>
  </div>
</template>
<script>
export default {
  name: "noData",
  props: {
    category: {
      type: String,
      default: "content.gif" //  暂无内容 content， 暂无优惠券 coupon, 暂无课程 lesson, 断网 network, 定位为空 position, 我的收藏collect, 订单order
    },
    tipword: {
      type: String,
      default: "暂无内容"
    },
    outStyle: {
      type: Object,
      default: () => ({
        height: "100%",
        paddingTop: "150px"
      })
    }
  },
  data() {
    return {
      timer: null,
      isShow: false
    };
  },
  created() {
    this.timer = setInterval(() => {
      this.isShow = true;
    }, 500);
  },
  beforeDestroy() {
    window.clearTimeout(this.timer);
  }
};
</script>
<style lang="scss" scoped>
.nodata {
  background: #ffffff;

  position: absolute;
  width: 100%;

  &-in {
    text-align: center;
  }
  &_img {
    display: inline-block;
    width: 187px;
  }
  &_word {
    font-size: 17px;
    font-weight: 400;
    color: rgba(34, 34, 34, 1);
  }
}
</style>
